import Vue from 'vue'
import Clipboard from 'clipboard'
import { language } from '@/common/storage'

function clipboardSuccess() {
  Vue.prototype.$message({
    message: language.get() === 'en' ? 'Copy Successful' : '复制成功',
    type: 'success',
    duration: 1500,
  })
}

function clipboardError() {
  Vue.prototype.$message({
    message: language.get() === 'en' ? 'Copy Failed' : '复制失败',
    type: 'error',
  })
}

export default function handleClipboard(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text,
  })
  clipboard.on('success', () => {
    clipboardSuccess()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    clipboardError()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}
